import { render, staticRenderFns } from "./GBrandDesignForm.vue?vue&type=template&id=05054ab2&scoped=true&"
import script from "./GBrandDesignForm.vue?vue&type=script&lang=ts&"
export * from "./GBrandDesignForm.vue?vue&type=script&lang=ts&"
import style0 from "./GBrandDesignForm.vue?vue&type=style&index=0&id=05054ab2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05054ab2",
  null
  
)

export default component.exports